import { Languages } from '@rp/shared/models';

import { EnvironmentModel } from '../../models/environment.model';

export const environment: EnvironmentModel = {
  production: false,
  uiConfig: {
    header: {
      shouldShowMyBalance: false,
      haveAccountSettings: false,
      havePersonalManager: false,
    },
    sidebar: [
      'finance',
      'adminStatistic',
      'advertisers',
      'partners',
      'offersWall',
      'promo',
      'streams',
      'rbac',
    ],
  },
  apiConfig: {
    adminApiHost: 'https://admin-gateway.rpartners-dev.com/api/v1',
    userApiHost: 'https://user-gateway.rpartners-dev.com/api/v1',
  },
  loginPageUrl: '/login',
  webmasterCabinetUrl: 'https://webmaster.rpartners-dev.com',
  advertiserCabinetUrl: 'https://advertiser.rpartners-dev.com',
  defaultLanguage: Languages.EN,
  languages: [Languages.EN, Languages.RU],
};
